import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetWebPageSubscriptionParams, WebPageService, WebPageSubscriptionGet } from '@app/services/web-page.service';

@Component({
    selector: 'tt-web-page-subscription',
    templateUrl: './web-page-subscription.component.html',
    styleUrls: ['./web-page-subscription.component.css'],
})
export class WebPageSubscriptionComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetWebPageSubscriptionParams;

    public get?: WebPageSubscriptionGet;

    public grid?: GridOptions;

    constructor(
        private webPage: WebPageService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_webpagesubscription.grid').setLoadDataFunction({ method: 4008, parameters: () => this.params });
        }
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.webPage.getWebPageSubscription(this.params);
        }
    }

    private async init() {
        this.readGrid();
        await this.loadGet();
        this.navigator?.setHeading?.(this.get?.webpage_heading ?? '');
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ height: '95vh', width: '98vw' });
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }
}
